import { Text, Alert } from '@mantine/core';
import { Info } from 'lucide-react';

interface ScoutChatTransitionIndicatorProps {
  messageCount: number;
}

export const ScoutChatTransitionIndicator = ({
  messageCount,
}: ScoutChatTransitionIndicatorProps) => {
  return (
    <Alert
      icon={<Info size={16} />}
      title='Continuing conversation'
      color='blue'
      variant='light'
      mb='md'
      style={{
        fontSize: '0.875rem',
      }}
    >
      <Text size='sm'>
        Your chat from the full-page view is continuing here.{' '}
        {messageCount > 0 &&
          `You have ${messageCount} message${messageCount === 1 ? '' : 's'} in this conversation.`}
      </Text>
    </Alert>
  );
};
